import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import "@/App.css";

import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import CustomCursor from "@/components/CustomCursor";
import Preloader from "@/components/Preloader";
import { Toaster } from "@/components/ui/sonner";

import Home from "@/pages/Home";
import Portfolio from "@/pages/Portfolio";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import Boutique from "@/pages/Boutique";
import Merci from "@/pages/Merci";
import { LangProvider } from "@/lib/i18n";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);
  return null;
};

const StripBadge = () => {
  useEffect(() => {
    const kill = () => {
      const ids = ["emergent-badge"];
      ids.forEach((id) => {
        const el = document.getElementById(id);
        if (el && el.parentNode) el.parentNode.removeChild(el);
      });
      document
        .querySelectorAll('a[href*="emergent.sh"], a[href*="app.emergent"]')
        .forEach((a) => a.parentNode && a.parentNode.removeChild(a));
    };
    kill();
    const mo = new MutationObserver(kill);
    mo.observe(document.body, { childList: true, subtree: true });
    return () => mo.disconnect();
  }, []);
  return null;
};

const PageTransitions = () => {
  const location = useLocation();
  return (
    <AnimatePresence mode="wait">
      <motion.div
        key={location.pathname}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{ duration: 0.22, ease: "easeOut" }}
      >
        <Routes location={location}>
          <Route path="/" element={<Home />} />
          <Route path="/portfolio" element={<Portfolio />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/boutique" element={<Boutique />} />
          <Route path="/merci" element={<Merci />} />
          <Route path="*" element={<Home />} />
        </Routes>
      </motion.div>
    </AnimatePresence>
  );
};

function App() {
  return (
    <div className="App">
      <LangProvider>
        <BrowserRouter>
          <ScrollToTop />
          <StripBadge />
          <CustomCursor />
          <Preloader />
          <Navbar />
          <PageTransitions />
          <Footer />
          <Toaster richColors position="bottom-right" />
        </BrowserRouter>
      </LangProvider>
    </div>
  );
}

export default App;
